import countryData from "../CountryData/allCountryData.json";

export default function useCountryCity(country: string, city: string) {
  const possibleCountries = Object.keys(countryData).filter((countryName) =>
    countryName.toLowerCase().startsWith(country.toLowerCase())
  );

  const possibleCities = (
    countryData?.[country as keyof typeof countryData] ?? []
  ).filter((cityName) => cityName.toLowerCase().startsWith(city.toLowerCase()));

  const validCountry = Boolean(
    countryData[country as keyof typeof countryData]
  );

  const validCity = Boolean(
    countryData?.[country as keyof typeof countryData]?.some(
      (cityName) => cityName === city
    )
  );

  return { possibleCities, possibleCountries, validCity, validCountry };
}
